import { thirdPartyWithLayoutService } from '@bedrock/fido-sdk';
import newrelicEngine from './newrelic.engine';

const ERROR = 'error';
const UNHANDLED_REJECTION = 'unhandledrejection';

const errorEventHandler = error => {
  newrelicEngine.sendError(error.error);
};

const unhandledRejectionEventHandler = error => {
  newrelicEngine.sendError(error.reason);
};

const thirdPartyErrorEventHandler = error => {
  thirdPartyWithLayoutService.sendErrorEvent(error.error);
};

const thirdPartyUnhandledRejectionEventHandler = error => {
  thirdPartyWithLayoutService.sendErrorEvent(error.reason);
};

export const handleBootErrors = () => {
  window.addEventListener(ERROR, errorEventHandler);
  window.addEventListener(UNHANDLED_REJECTION, unhandledRejectionEventHandler);
};

export const unsubscribeBootErrorHandlers = () => {
  window.removeEventListener(ERROR, errorEventHandler);
  window.removeEventListener(UNHANDLED_REJECTION, unhandledRejectionEventHandler);
};

export const switchToThirdPartyHandlers = () => {
  window.addEventListener(ERROR, thirdPartyErrorEventHandler);
  window.addEventListener(UNHANDLED_REJECTION, thirdPartyUnhandledRejectionEventHandler);

  unsubscribeBootErrorHandlers();
};

export const unsubscribeThirdPartyErrorHandlers = () => {
  window.removeEventListener(ERROR, thirdPartyErrorEventHandler);
  window.removeEventListener(UNHANDLED_REJECTION, thirdPartyUnhandledRejectionEventHandler);
};
